import React, { createContext, useContext } from 'react';
import { getUserPermissions } from './Permission';

const PermissionContext = createContext([]);

export const PermissionProvider = ({ children }) => {
  const permissions = getUserPermissions();
  return (
    <PermissionContext.Provider value={permissions}>
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermissions = () => useContext(PermissionContext);